//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        tabs: Array,
        type: {
            type: Number
        }
    }
}
